class CartPage extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.dataset.sectionId;
    this.quantityInputs = this.querySelectorAll("[name='updates[]']");
    this.freeShippingBar = this.querySelector("free-shipping-bar");
    this.shippingEstimate = this.querySelector(".shipping-estimate");
    this.giftWrap = this.querySelector(".gift-wrap");

    this.debouncedOnChange = theme.helpers.debounce((event) => {
      this.onChange(event);
    }, 300);

    this.initCartActions();
  }

  initCartActions() {
    this.quantityInputs = this.querySelectorAll("[name='updates[]']");
    this.shippingEstimate = this.querySelector(".shipping-estimate");
    this.giftWrap = this.querySelector(".gift-wrap");

    // Inputs
    this.quantityInputs.forEach((input) => {
      input.removeEventListener("change", this.debouncedOnChange.bind(this), false);
      input.addEventListener("change", this.debouncedOnChange.bind(this), false);
    });

    // Shipping estimate
    this.addressCountry = this.shippingEstimate?.querySelector("#AddressCountry");
    this.addressProvince = this.shippingEstimate?.querySelector("#AddressProvince");
    this.addressZip = this.shippingEstimate?.querySelector("#AddressZip");
    this.shippingEstimateButton = this.shippingEstimate?.querySelector(".shipping-estimate__button");

    if (this.addressCountry && this.addressProvince) {
      if (!this.shippingEstimate.classList.contains("shipping-estimate--inited")) {
        new Shopify.CountryProvinceSelector(
          "AddressCountry",
          "AddressProvince",
          { hideElement: "AddressProvinceContainer" }
        );

        this.shippingEstimate.classList.add("shipping-estimate--inited");
      }

      if (this.shippingEstimateButton) {
        this.shippingEstimateButton.removeEventListener("click", this.initShippingEstimate.bind(this), false);
        this.shippingEstimateButton.addEventListener("click", this.initShippingEstimate.bind(this), false);
      }
    }

    // Gift wrap
    if (this.giftWrap) {
      const giftWrapInput = this.giftWrap.querySelector("input[type='checkbox']");

      giftWrapInput?.removeEventListener("change", this.initGiftWrap.bind(this), false);
      giftWrapInput?.addEventListener("change", this.initGiftWrap.bind(this), false);
    }
  }

  initGiftWrap(event) {
    const target = event.currentTarget;

    if (target.checked) {
      this.addGiftWrapProduct(target);
    } else {
      this.updateQuantity(target.dataset.index, 0);
    }
  }

  addGiftWrapProduct(target) {
    const id = +target.dataset.variantId;

    const body = JSON.stringify({
      id: id,
      quantity: 1,
      sections_url: window.location.pathname,
      sections: this.getSectionsToRender().map((section) => {
        return section.name;
      }),
    });

    this.classList.add("start", "loading");

    fetch(`${window.routes.cartAddUrl}`, { ...theme.helpers.fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        this.updateCart(id, state, target);
      })
      .catch((e) => {
        throw e;
      })
      .finally(() => {
        this.classList.remove("start", "loading");
      });
  }

  initShippingEstimate(event) {
    event.preventDefault();

    const target = event.currentTarget;

    target.classList.add("loading");

    const data = {
      country: this.addressCountry.value || "",
      province: this.addressProvince.value || "",
      zip: this.addressZip.value || "",
    };

    this.getShippingRates(data, target);
  }

  getShippingRates(data, button) {
    fetch(`${window.Shopify.routes.root}cart/shipping_rates.json?shipping_address%5Bzip%5D=${data.zip}&shipping_address%5Bcountry%5D=${data.country}&shipping_address%5Bprovince%5D=${data.province}`)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const message = this.querySelector(".shipping-response");
        const successBanner = message.querySelector(".color-success");
        const errorBanner = message.querySelector(".color-error");

        message.classList.remove("!hidden");
        successBanner.classList.add("!hidden");
        errorBanner.classList.add("!hidden");

        const {
          showDeliveryDays,
          deliveryDayOne,
          deliveryDaysOther
        } = message.dataset;

        const parsedState = JSON.parse(state);

        if (parsedState && parsedState.shipping_rates) {
          if (parsedState.shipping_rates.length > 0) {
            successBanner.classList.remove("!hidden");

            const contentBlock = successBanner.querySelector("span");
            const addressInfo = window.cartStrings.shippingRate.replace("{{address}}", `${data.zip}, ${data.country} ${data.province}`);

            let content = `<p>${addressInfo}</p>`;

            parsedState.shipping_rates.map((rate) => {
              let daysShipping = "";

              if (rate.delivery_days.length > 0 && showDeliveryDays === "true") {
                let typeDay = deliveryDayOne;
                const day = rate.delivery_days[0];
                const dayAt = rate.delivery_days.at(-1);

                if (day > 1) {
                  typeDay = deliveryDaysOther;
                }

                if (day === dayAt) {
                  daysShipping = `(${day} ${typeDay})`;
                } else {
                  daysShipping = `(${day} - ${dayAt} ${typeDay})`;
                }
              }

              content += `<p>${rate.name}: ${Shopify.formatMoney(rate.price, window.settings.moneyFormat)} ${daysShipping}</p>`;
            });

            contentBlock.innerHTML = content;
          } else {
            errorBanner.classList.remove("!hidden");

            const contentBlock = errorBanner.querySelector("span");

            contentBlock.innerHTML = window.cartStrings.noShipping;
          }
        } else {
          errorBanner.classList.remove("!hidden");

          const contentBlock = errorBanner.querySelector("span");

          let content = "";

          Object.entries(parsedState).map((error) => {
            content += `${error[1][0]}<br>`;
          });

          contentBlock.innerHTML = content;
        }
      })
      .catch((error) => {
        throw error;
      }).finally(() => {
      button?.classList.remove("loading");
    });
  }

  onChange(event) {
    const target = event.target;

    this.updateQuantity(target.dataset.index, target.value, target.dataset.value, target);
  }

  updateQuantity(id, quantity, currentQuantity, target) {
    quantity = quantity ? quantity : 0;

    const body = JSON.stringify({
      line: +id,
      quantity: +quantity,
      sections_url: window.location.pathname,
      sections: this.getSectionsToRender().map((section) => {
        return section.name;
      }),
    });

    this.classList.add("start", "loading");

    fetch(`${window.routes.cartChangeUrl}`, { ...theme.helpers.fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        this.updateCart(id, state, target);
      })
      .catch((e) => {
        throw e;
      })
      .finally(() => {
        this.classList.remove("start", "loading");
      });
  }

  updateCart(id, state, target) {
    const parsedState = JSON.parse(state);

    if (parsedState.errors) {
      this.updateMessageErrors(id, parsedState.errors, target);

      target.value = target.dataset.value;

      return;
    }

    document.dispatchEvent(new CustomEvent("theme:cart:count:update", {
      detail: {
        count: parsedState.item_count
      }
    }));

    this.getSectionsToRender().forEach((section) => {
      const html = new DOMParser().parseFromString(parsedState.sections[section.name], "text/html");
      const currentSection = document.getElementById(section.id);

      if (parsedState.item_count === 0) {
        const parsedSection = html.getElementById(section.id);

        currentSection.innerHTML = parsedSection.innerHTML;

        this.classList.add("is-empty");
      } else {
        const currentProducts = currentSection.querySelector(".main-cart__content");
        const currentTotals = currentSection.querySelector(".cart-info .totals");
        const currentDiscounts = currentSection.querySelector(".cart-page__discounts");

        const parsedProducts = html.querySelector(".main-cart__content");
        const parsedTotals = html.querySelector(".cart-info .totals");
        const parsedDiscounts = html.querySelector(".cart-page__discounts");

        currentProducts.innerHTML = parsedProducts.innerHTML;
        currentTotals.innerHTML = parsedTotals.innerHTML;

        if (currentDiscounts && parsedDiscounts) {
          currentDiscounts.innerHTML = parsedDiscounts.innerHTML;
        }

        this.classList.remove("is-empty");

        const focusableElement = currentProducts?.querySelector("a");

        focusableElement?.focus();
      }
    });

    this.freeShippingBar = this.querySelector("free-shipping-bar");

    if (this.freeShippingBar) {
      if (parsedState.items_subtotal_price) {
        this.freeShippingBar.init(parsedState.items_subtotal_price);
      } else {
        fetch(`${window.routes.cartUrl}.json`)
          .then((res) => res.json())
          .then((cart) => {
            this.freeShippingBar.init(cart.items_subtotal_price);
          })
          .catch((error) => {
            throw error;
          });
      }
    }

    this.initCartActions();

    document.dispatchEvent(new CustomEvent("hover-button:apply"));
  }

  getSectionsToRender() {
    return [
      {
        name: this.sectionId,
        id: "CartPage",
      },
    ];
  }

  updateMessageErrors(line, message, target) {
    target.setCustomValidity(message);
    target.reportValidity();
  }
}

if (!window.customElements.get("cart-page")) {
  customElements.define("cart-page", CartPage);
}
